// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconMagnifyingGlass = createRemixIcon('IconMagnifyingGlass', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 0a11 11 0 1 0 6.442 19.917L21.525 24L24 21.525l-4.083-4.083A11 11 0 0 0 11 0M4.99 4.99a8.5 8.5 0 1 1 12.02 12.02A8.5 8.5 0 0 1 4.99 4.99\" clip-rule=\"evenodd\"/>");
